/** Compañía predeterminada para Facturas de Compra (preferencia local del navegador). */

const STORAGE_KEY = 'idCompaniaDefaultCompras';

export function readCompaniaDefaultCompras(): string | null {
  try {
    const id = String(localStorage.getItem(STORAGE_KEY) ?? '').trim();
    return id || null;
  } catch {
    return null;
  }
}

export function persistCompaniaDefaultCompras(idCompania: string | null): void {
  try {
    const id = String(idCompania ?? '').trim();
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {}
}
